import { createQueryKeys } from '@lukemorales/query-key-factory'

import { orderService } from '@/domain/Order'
import { ListOrdersDto } from '@/domain/Order/dtos/list-orders'

export const orders = createQueryKeys('orders', {
    listOrders: (dto: ListOrdersDto) => ({
        queryKey: ['all', dto.page],
        queryFn: () => orderService.listOrders(dto),
    }),
    retrieveOrder: (orderId: string) => ({
        queryKey: ['retrieve', orderId],
        queryFn: () => orderService.retrieveOrder(orderId),
    }),
})
